import React, { useEffect, useState, useRef } from 'react';
import { Button, Card, CardBody, Col, Container, FormGroup, Input, Row, Spinner } from 'reactstrap';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import Select from 'react-select';
import { CSVLink } from "react-csv";

//Services
import { api_GET, api_POST } from '../../../../services/api_service';
import { showMessage } from '../../../../services/message';
import { getSessionCookie } from '../../../../services/session';

//CSS
import "../../../../assets/css/loading.css";

//Components
import Header from '../../../../components/Headers/Header';

//Helpers
import { formateDateApi } from '../../../../helpers/formats';
import RelatorioQualidadeAnalitico from './RelatorioQualidadeAnalitico';

function initialStateCabecalho() {
  return {
    modalidade: "",
    dataInicio: "",
    dataFim: "",
    divisaoAdministrativa: "",
    planoTrabalho: "",
    statusAvaliacao: "Todos"
  }
}
function QualidadeAnalitico({ history }) {
  const { register, errors, setValue, clearErrors } = useForm({ mode: "onBlur" });

  const [showLoading, setshowLoading] = useState(false);

  const session = getSessionCookie();

  const exportRef = useRef(null);

  const [inicio, setInicio] = useState(formateDateApi(moment().subtract(1, 'month')));
  const [fim, setFim] = useState(formateDateApi(moment(new Date())));

  //State para pegar dados para cabeçalho
  const [cabecalho, setCabecalho] = useState(initialStateCabecalho());

  const headersExport = [
    { label: 'MODALIDADE DE SERVIÇO', key: 'modalidade' },
    { label: 'PLANO DE TRABALHO', key: 'planoTrabalho' },
    { label: 'OPERADOR', key: 'operador' },
    { label: 'RECURSO', key: 'veiculo' },
    { label: 'DATA/HORA - INÍCIO DA EXECUÇÃO', key: 'dataHoraExecucaoInicio' },
    { label: 'DATA/HORA - FIM DA EXECUÇÃO', key: 'dataHoraExecucaoFim' },
    { label: 'PROGRAMADOS', key: 'programadas' },
    { label: 'AVULSOS', key: 'avulsa' },
    { label: 'EXECUÇÕES TOTAIS', key: 'execucaoTotal' },
    { label: 'EXECUÇÕES PARCIAIS', key: 'execucaoParcial' },
    { label: 'JUSTIFICATIVA(S) DE EXECUÇÃO PARCIAL', key: 'justificativaParcial' },
    { label: 'NÃO EXECUÇÕES', key: 'naoExecucao' },
    { label: 'JUSTIFICATIVA(S) DA NÃO EXECUÇÃO', key: 'justificativaNaoExecucao' },
    { label: 'ÍNDICE DE QUALIDADE DA EXECUÇÃO (%)', key: 'porcentagemIndiceQualidade' },
    { label: 'ÍNDICE DE QUALIDADE DA EXECUÇÃO (CONDIÇÃO)', key: 'condicao' },
    { label: 'USUÁRIO RESPONSÁVEL PELA AVALIAÇÃO DA ORDEM DE SERVIÇO', key: 'usuarioAvaliacao' },
    { label: 'STATUS DA ORDEM DE SERVIÇO', key: 'statusAvaliacao' },
  ]
  const [csvData, set_csvData] = useState([]);

  //State para pegar o status da avaliação
  const [statusAvaliacaoColeta, setStatusAvaliacaoColeta] = useState({ label: "Todos", value: null })

  //State das options de status de avaliacao
  const [optionsStatusAvaliacao, setOptionsStatusAvaliacao] = useState([
    { label: "Todos", value: null },
    { label: "Aprovada", value: "Aprovada" },
    { label: "Aprovação Automática", value: "Aprovação Automática" },
    { label: "Contestada", value: "Contestada" },
    { label: "Justificada", value: "Justificada" },
    { label: "Reprovada", value: "Reprovada" },
    { label: "Pendente", value: "Pendente" },
  ])

  // Modalidade
  const [optionsModalidadesColeta, setoptionsModalidadesColeta] = useState([]);
  const [modalidadesColeta, setModalidadesColeta] = useState({ descricao: "Todas", modalidadeColetaId: null });
  const loadOptionsModalidadesColeta = () => {
    api_GET(`modalidadeColeta`).then(result => {
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        setoptionsModalidadesColeta([{ descricao: "Todas", modalidadeColetaId: null }, ...result.data]);
      }
    });
  }

  const [optionsPlanoTrabalho, setOptionsPlanoTrabalho] = useState([]);
  const [planoTrabalho, setPlanoTrabalho] = useState({ descricao: "Todos", setorColetaId: null });
  const laodPlanoTrabalho = () => {
    setshowLoading(true);
    api_GET("setorcoleta").then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        setOptionsPlanoTrabalho([{ descricao: "Todos", setorColetaId: null }, ...result.data]);
      }
    });
  };

  const [optionsConcessionaria, setOptionsConcessionaria] = useState([])
  const [concessionaria, setConcessionaria] = useState({ identificacao: "Todas", concessionariaId: null });
  const loadConcessionarias = () => {
    api_GET(`Concessionaria`).then(result => {
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        setOptionsConcessionaria([{ identificacao: "Todas", concessionariaId: null }, ...result.data]);
      }
    });
  }

  const [optionsRegional, setOptionsRegional] = useState([]);
  const [regional, setRegional] = useState({ descricao: "Todas", regionalId: null });
  const loadOptionsRegional = () => {
    api_GET(`regional`).then(result => {
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        setOptionsRegional([{ descricao: "Todas", regionalId: null }, ...result.data]);
      }
    });
  }


  const handleModalidadesColeta = (value) => {
    setModalidadesColeta(value);
  }

  const handlePlanoTrabalho = (value) => {
    setPlanoTrabalho(value);
  }

  const handleConcessioria = (value) => {
    setConcessionaria(value)
  }

  useEffect(() => {
    loadOptionsModalidadesColeta();
    laodPlanoTrabalho();
    loadOptionsRegional();
    loadConcessionarias();

    if (session != null && session.perfil == "Adm")
      setConcessionaria({ concessionariaId: session.concessionariaId })
  }, []);

  const [relatorioQualidadeAnalitica, setRelatorioQualidadeAnalitica] = useState(null);
  const handleGerarRelatorio = (gerarExcel = false) => {
    if (modalidadesColeta == null) {
      showMessage("Aviso", "Por favor, Selecione a modalidade de coleta.", "warning", null);
      return;
    }

    if (regional == null) {
      showMessage("Aviso", "Por favor, Selecione a divisão administrativa.", "warning", null);
      return;
    }

    if (planoTrabalho == null) {
      showMessage("Aviso", "Por favor, Selecione a plano de trabalho.", "warning", null);
      return;
    }

    const json = {
      modalidadeColetaId: modalidadesColeta.modalidadeColetaId,
      dataInicio: inicio,
      dataFim: fim,
      setorColetaId: planoTrabalho.setorColetaId,
      statusAvaliacao: statusAvaliacaoColeta.value,
      regionalId: regional.regionalId,
      concessionariaId: concessionaria.concessionariaId
    }

    setCabecalho({
      dataFim: fim,
      dataInicio: inicio,
      modalidade: modalidadesColeta.descricao,
      planoTrabalho: planoTrabalho.descricao,
      divisaoAdministrativa: regional.descricao,
      statusAvaliacao: statusAvaliacaoColeta.label
    })

    setshowLoading(true);
    api_POST("Relatorio/RelatorioQualidadeAnalitico", json).then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
        return;
      }
      else {
        if (!gerarExcel)
          setRelatorioQualidadeAnalitica(result.data);
        else {
          set_csvData(result.data);
          if (exportRef.current)
            exportRef.current.link.click();
        }
      }
    });
  }

  const handleGerarExcel = () => {
    handleGerarRelatorio(true);
  }

  const handleReturn = () => {
    setRelatorioQualidadeAnalitica(null)
    setPlanoTrabalho(null);
    setModalidadesColeta(null);
    setRegional(null);
    setInicio(formateDateApi(moment().subtract(1, 'month')));
    setFim(formateDateApi(moment(new Date())));
    setCabecalho(initialStateCabecalho())
  }

  return <>
    {showLoading &&
      <div className="carregandoCmp">
        <div className="box">
          <label style={{ marginRight: "20px" }}>Carregando...</label>
          <Spinner size="sm" color="info" />
        </div>
      </div>
    }
    {!relatorioQualidadeAnalitica &&
      <>
        <Header />
        <Container className="mt--9" fluid>
          <Row>
            <Container className="mt-1" fluid>
              <div className='d-flex justify-content-between align-items-center mb-1'>
                <Button color="secondary" type="button" onClick={() => history.goBack()}>
                  Voltar
                </Button>
              </div>
              <Card className="shadow">
                <CardBody>
                  <div className='d-flex justify-content-end items-align-center mb-1'>
                    <span className='text-danger'>* Campos Obrigatórios</span>
                  </div>
                  <Row>
                    <Col md="4" lg="3">
                      <FormGroup >
                        <label className="form-control-label">
                          Concessionarias
                        </label>
                        <Select
                          options={optionsConcessionaria}
                          getOptionLabel={({ identificacao }) => identificacao}
                          getOptionValue={({ concessionariaId }) => concessionariaId}
                          onChange={(value) => { handleConcessioria(value) }}
                          isDisabled={session.perfil == "Adm"}
                          value={optionsConcessionaria.find(x => x.concessionariaId == concessionaria.concessionariaId)}
                          placeholder="Selecione"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12" lg="2">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-address" >
                          * Data Início
                        </label>
                        <Input
                          className="form-control-alternative"
                          innerRef={register({ required: true })}
                          defaultValue={inicio ? formateDateApi(inicio) : ""}
                          name="dataInicio"
                          placeholder="Data Início"
                          type="date"
                          max={formateDateApi(moment(new Date()))}
                          onBlur={(e) => setInicio(formateDateApi(e.target.value))}
                        />
                        {errors.dataInicio && <span className="form-control-label">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                    <Col md="12" lg="2">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-address" >
                          * Data Fim
                        </label>
                        <Input
                          className="form-control-alternative"
                          innerRef={register({ required: true })}
                          defaultValue={fim ? formateDateApi(fim) : ""}
                          name="dataFim"
                          placeholder="Data Fim"
                          type="date"
                          max={formateDateApi(moment(new Date()))}
                          onBlur={(e) => setFim(formateDateApi(e.target.value))}
                        />
                        {errors.dataFim && <span className="form-control-label">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                    <Col md="4" lg="5">
                      <FormGroup >
                        <label className="form-control-label">
                          * Modalidades de Serviço
                        </label>
                        <Select
                          options={optionsModalidadesColeta}
                          getOptionLabel={({ descricao }) => descricao}
                          getOptionValue={({ modalidadeColetaId }) => modalidadeColetaId}
                          onChange={(value) => { handleModalidadesColeta(value) }}
                          value={modalidadesColeta ? optionsModalidadesColeta.filter(x => x.modalidadeColetaId == modalidadesColeta.modalidadeColetaId)[0] : null}
                          placeholder="Selecione"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="4" lg="3">
                      <FormGroup >
                        <label className="form-control-label">
                          Status de Avaliação da Ordem
                        </label>
                        <Select
                          options={optionsStatusAvaliacao}
                          getOptionLabel={({ label }) => label}
                          getOptionValue={({ value }) => value}
                          onChange={(value) => { setStatusAvaliacaoColeta(value) }}
                          value={statusAvaliacaoColeta ? optionsStatusAvaliacao.filter(x => x.value == statusAvaliacaoColeta.value)[0] : null}
                          placeholder="Selecione"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12" lg="3">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-address" >
                          * Divisão Administrativa
                        </label>
                        <Select
                          name="regional"
                          options={optionsRegional}
                          getOptionLabel={({ descricao }) => descricao}
                          getOptionValue={({ regionalId }) => regionalId}
                          onChange={(value) => { setRegional(value) }}
                          value={regional != null && optionsRegional.find(obj => obj.regionalId === regional.regionalId)}
                          placeholder="Selecione"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12" lg="3">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-address" >
                          * Plano de Trabalho
                        </label>
                        <Select
                          name="planoTrabalho"
                          options={optionsPlanoTrabalho}
                          getOptionLabel={({ descricao }) => descricao}
                          getOptionValue={({ setorColetaId }) => setorColetaId}
                          onChange={(value) => handlePlanoTrabalho(value)}
                          value={planoTrabalho != null && optionsPlanoTrabalho.find(obj => obj.setorColetaId === planoTrabalho.setorColetaId)}
                          placeholder="Selecione"
                        />
                      </FormGroup>
                    </Col>
                    <Col className="text-center" lg="12">
                      <Button
                        color="danger"
                        type="button"
                        onClick={() => handleGerarRelatorio(false)}>
                        GERAR PDF
                      </Button>
                      <Button
                        color="success"
                        type="button"
                        onClick={handleGerarExcel}>
                          GERAR CSV
                      </Button>
                      {csvData.length > 0 &&
                        <CSVLink
                          data={csvData}
                          headers={headersExport}
                          filename="RelatorioQualidadeAnalitico.csv"
                          target="_blank"
                          separator={";"}
                          ref={exportRef}
                        >
                        </CSVLink>
                      }
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Container>
          </Row>
        </Container>
      </>
    }

    {relatorioQualidadeAnalitica &&
      <RelatorioQualidadeAnalitico
        handleReturn={handleReturn}
        relatorio={relatorioQualidadeAnalitica}
        cabecalho={cabecalho}
      />
    }
  </>
}

export default QualidadeAnalitico;